import './polyfills';
import React from 'react';
import ReactDOM from 'react-dom/client';
import config from 'devextreme/core/config';
import './index.css';
import { App } from './App';
import { licenseKey } from './devextreme-license';

config({ licenseKey });

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  // <React.StrictMode>
  <App />
  // </React.StrictMode>
);
